import React from 'react';
import { Route } from 'react-router-dom';
import 'react-table/react-table.css';
import Home from '../Containers/Home';
import News from '../Containers/News';
import Helpdesk from './Helpdesk';
import ShoppingCart from '../Containers/ShoppingCart';
import Settings from './Settings';
import NewsDetail from '../Containers/NewsDetail';
import Catalog from './Catalog';
import Marketing from './Marketing';
import Shop from './Shop';
import Buy from './Buy';
import FileViewer from '../Containers/PDFFileViewer';

class Router extends React.Component {
  render() {
    return (
      <Route path="/">
        <React.Fragment>
          <Route exact path="/" component={News} />
          <Route path="/shopping-cart/:step?" component={ShoppingCart} />
          <Route path="/home" exact component={Home} />
          <Route path="/news" exact component={News} />
          <Route path="/settings" component={Settings} />
          <Route path="/helpdesk" component={Helpdesk} />
          <Route path="/news/:id" component={NewsDetail} />
          <Route path="/shop" component={Shop} />
          <Route path="/marketing" component={Marketing} />
          <Route path="/catalog" component={Catalog} />
          <Route path="/buy" component={Buy} />
          <Route
            path="/fileviewer"
            render={({ location }) => <FileViewer location={location} />}
          />

          {/* <Route render={() => <Redirect to="/home" />} /> */}
        </React.Fragment>
      </Route>
    );
  }
}

Router.propTypes = {};

Router.defaultProps = {};

export default Router;



// WEBPACK FOOTER //
// ./src/Routes/index.js